import { render, staticRenderFns } from "./OrganizationFilter.vue?vue&type=template&id=1778e6e8"
import script from "./OrganizationFilter.vue?vue&type=script&lang=ts"
export * from "./OrganizationFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports